import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {Box, Grid, Paper} from '@mui/material'
import Stack from '@mui/material/Stack'
import {classes} from '../../PersonaSummary/SummaryComponentStyles'
import {classesIP} from '../selectedPersonaStyles'
import OverviewLinearProgress from './OverviewLinearProgress'
import {SuperscriptDagger} from '../../../common/Dagger'

const OverviewKeyChar2 = ({averageAge, gender, demographics, isZeroCountPopulation}) => {
  return (
    <>
      <Box className={classesIP.overviewBox}>
        <Paper elevation={1} className={classes.summaryPadding}>
          <Stack alignItems='center' direction='row'>
            <Grid container direction='row'>
              <Grid item xs={4} direction={'column'} sx={{mt: 5}}>
                <Grid
                  direction='column'
                  className={classesIP.overviewKeyChar2Stack}
                  tabIndex={0}
                  aria-label={`${averageAge}, Average Age`}
                >
                  <Typography className={[classes.summaryStackTitle, classes.summaryTitleColorTeal]}>
                    {averageAge}
                    {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                  </Typography>
                  <Typography sx={{mt: -5}} className={classesIP.personaStackText}>
                    Average Age
                  </Typography>
                </Grid>
                <Grid
                  direction='column'
                  className={classesIP.overviewKeyChar2Stack}
                  mt={2}
                  tabIndex={0}
                  aria-label={`${gender[0]?.percentage}, ${gender[0]?.title}`}
                >
                  <Typography className={[classes.summaryStackTitle, classes.summaryTitleColorTeal]}>
                    {gender[0]?.percentage}
                    {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                  </Typography>
                  <Typography className={classesIP.personaStackText}>{gender[0]?.title}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ml: 2}}>
                <OverviewLinearProgress data={demographics} />
              </Grid>
            </Grid>
          </Stack>
        </Paper>
      </Box>

      {/* <StyledDivider /> */}
    </>
  )
}
OverviewKeyChar2.propTypes = {
  averageAge: PropTypes.number.isRequired,
  gender: PropTypes.array.isRequired,
  demographics: PropTypes.array.isRequired,
  isZeroCountPopulation: PropTypes.bool.isRequired
}

export default OverviewKeyChar2
